import { render } from "./Results.vue?vue&type=template&id=b9b1d85e&scoped=true"
import script from "./Results.vue?vue&type=script&lang=ts"
export * from "./Results.vue?vue&type=script&lang=ts"

import "./Results.vue?vue&type=style&index=0&id=b9b1d85e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b9b1d85e"

export default script